import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentContent, setCurrentContent] = useState(0);

  const heroContents = [
    {
      id: 1,
      title: "Empowering African Businesses with Innovative Software Solutions",
      subtitle: "We build world-class digital products that drive growth and transformation across Africa"
    },
    {
      id: 2,
      title: "Local Expertise, Global Standards",
      subtitle: "African developers delivering world-class software solutions with deep understanding of local markets"
    },
    {
      id: 3,
      title: "Digital Transformation Made Simple",
      subtitle: "From concept to deployment, we help African businesses embrace the digital future"
    },
    {
      id: 4,
      title: "Building Africa's Tech Future",
      subtitle: "Innovative software solutions that solve real African challenges and drive economic growth"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentContent((prev) => (prev + 1) % heroContents.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [heroContents.length]);

  return (
    <section className="hero">
      <div className="hero-slider">
        <div className="hero-slide active">
          <div className="hero-bg">
            <img src="https://www.cybage.com/sites/default/files/2025-02/30%20years_mobile_Web_1920x868_0.webp" alt="Ororo Software Solutions" />
          </div>
          <div className="hero-content">
            <div className="container">
              {heroContents.map((content, index) => (
                <div
                  key={content.id}
                  className={`hero-text-content ${index === currentContent ? 'active' : ''}`}
                >
                  <h1 className="hero-title">{content.title}</h1>
                  <h2 className="hero-subtitle">{content.subtitle}</h2>
                  <div className="hero-actions">
                    <a href="#contact" className="btn btn-outline">Contact us ➔</a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Content Indicators */}
      <div className="hero-content-indicators">
        {heroContents.map((_, index) => (
          <button
            key={index}
            className={`content-indicator ${index === currentContent ? 'active' : ''}`}
            onClick={() => setCurrentContent(index)}
            aria-label={`Go to content ${index + 1}`}
          ></button>
        ))}
      </div>
    </section>
  );
};

export default Hero; 